const railway = "https://backendakf-production.up.railway.app";
const render = "https://backend-akf.onrender.com";
const local = "http://127.0.0.1:8000";

export const urlApi = render;
